import { render, staticRenderFns } from "./FeedContentSendCv.vue?vue&type=template&id=4ddadbf1"
import script from "./FeedContentSendCv.vue?vue&type=script&lang=js"
export * from "./FeedContentSendCv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports